"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
var styles_1 = require("@material-ui/core/styles");
var themes_1 = require("../../themes");
var utils_1 = require("../../utils");
exports.useStyles = (0, styles_1.makeStyles)(function (theme) {
    return (0, styles_1.createStyles)({
        paper: {
            '& .MuiPaper-root': {
                minWidth: '200px',
                boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.15)',
                borderRadius: 0,
                '& .MuiList-root': {
                    padding: 0,
                },
            },
        },
        menuItem: {
            padding: '10px 12px',
            color: theme.palette.text.primary,
            '& .MuiTypography-root': {
                fontSize: utils_1.textSizeMap.text.medium,
            },
            '&:hover': {
                backgroundColor: themes_1.materialColors.blue[100],
                '& .MuiTypography-root': {
                    fontWeight: utils_1.textWeightMap.bold,
                },
            },
        },
        itemIcon: {
            minWidth: 'unset',
            marginRight: '12px',
            color: theme.palette.text.primary,
        },
    });
});
